import React, { Component } from 'react'
// connect方法的作用：将额外的props传递给组件，并返回新的组件，组件在该过程中不会受到影响
import { connect } from 'react-redux'
import Cookies from 'js-cookie';
import { NetGet, NetPost } from '../../axios'
import { toast } from 'react-toastify'
import './rightbox.css'
import LazyImg from '../lazyimg';
import paragraph from '../emoji/emojtanhtml';




export default class RightBox extends Component {
    state = {
        data: {
            mathart: [],
            beltstartresult: [],
            artleng:'',
            beleng:''
        }
    }

    componentDidMount(){
        this.getData()
    }

    getData = () => {
        NetGet("statistics", {  })
            .then((e) => {

                if (e.code == 0) {
                   this.setState({
                       data:e.data
                   })
                } else {
                    toast.error("文章获取失败 !");

                }
            })
            .catch(() => {
                toast.error("文章获取失败 !");

            })
    }


    renderReplay = () => {
        return this.state.data.beltstartresult.map((e, i) => {


            
            var link = ''
            switch (e.articleid) {
                case 0:
                    link="/#/Board?beldid="+ e.id
                    break;
                case -1:
                    link="/#/FriendsLink?beldid="+ e.id
                    break;
                case -2:
                    link="/#/About?beldid="+ e.id
                    break;
                default:
                    link="article/"+e.articleid+"?beldid="+ e.id
                    break;
            }
            
            return <a class="d-flex pb-3 px-3 a-none"
            title={e.name+"\n"+e.body}
            href={link}>
                <LazyImg className="sidebar-comment-avatar mr-1" src={e.headimg} loadimg="https://image.bestzuo.cn/images/20200621224833.gif!getwebp" errimg={require("../../img/defheader.png")}/>
                <div class="w-100">
                    <div class="d-flex sidebar-comment-info">
                        <div class="sidebar-comment-name" >{e.name}</div>
                        <div class="sidebar-comment-date">{e.time}</div>
                    </div>
                    <div class="sidebar-comment-text">
                        {paragraph(e.body)}
                    </div>
                </div>
            </a>

        })
    }


    renderMathArt = () => {
        return this.state.data.mathart.map((e, i) => {
            return <div class="pb-3 px-3">
                <div class="sidebar-rand-item">
                    <a class="sidebar-rand-img" href={`/article/${e.id}`} target="_blank" style={{ backgroundImage: `url(${e.posvimg})` }}>
                    </a>
                    <div class="sidebar-rand-info p-2">
                        <div class="sidebar-rand-date"><i class="far fa-clock"></i>{e.time}</div>
                        <a href={`/article/${e.id}`} class="sidebar-rand-title a-none">{e.title}</a>
                    </div>
                </div>
            </div>
        })
    }

    render() {
        const {data } = this.state
        return (
            <div className={`sidebar ${this.props.className ? this.props.className : ''}`}>


                <div id="sidebar-box" class="h-100">
                    <div class="sidebar-box position-relative">
                        <div class="sidebar-banner" style={{}}>
                        </div>
                        <div class="text-center">
                            <img class="sidebar-avatar position-absolute" src="https://ningcat.com/coverimg/headimg" />
                        </div>
                        <div class="sidebar-name">猫 宁</div>
                        <div class="sidebar-info">
                            <div class="sidebar-post-number"><span>文章</span>{data.artleng}</div>
                            <div class="sidebar-categories-number"><span>评论</span>{data.beleng}</div>
                            <div class="sidebar-tags-number"><span>标签</span>1</div>
                        </div>
                    </div>
                    {
                        this.state.data.beltstartresult.length > 0 &&
                        <div class="sidebar-box">
                            <div class="p-3">最新回复</div>
                            {this.renderReplay()}
                        </div>
                    }

                    {
                        this.state.data.mathart.length > 0 &&
                        <div class="sidebar-box sticky-top">
                            <div class="p-3">随便看看</div>
                            {this.renderMathArt()}
                        </div>
                    }
                </div>
            </div>
        )
    }


}